/**
 * Auto-récupération après un déploiement (stack Ben 17/08, herbo-prep) : un
 * onglet resté ouvert AVANT un rebuild référence des chunks Vite hashés qui
 * n'existent plus une fois le nouveau build en ligne (`build.emptyOutDir`
 * supprime les anciens assets) → 404 sur l'import dynamique (`React.lazy`)
 * en navigation DOUCE, jamais au F5 (l'index HTML frais pointe déjà vers les
 * bons hashes). Observé : « TypeError: Failed to fetch dynamically imported
 * module: .../CommandeTisanes-BLgAnGfq.js ». On a redéployé 4+ fois ce
 * jour-là → toutes les sessions ouvertes cassaient au premier clic.
 *
 * Détection + rechargement UNE fois (anti-boucle via `sessionStorage`) : si
 * le rechargement retombe sur la même erreur (déploiement réellement cassé,
 * pas juste un skew de version), on abandonne et affiche l'écran d'erreur
 * normal plutôt que de boucler indéfiniment.
 */

const CLE_TENTATIVE = 'herbo-chunk-reload-tente';

/** Vrai si l'erreur ressemble à un chunk Vite manquant après redéploiement —
 *  jamais une vraie erreur applicative, pour ne recharger QUE ce cas précis. */
export function estErreurChunkManquant(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  if (error.name === 'ChunkLoadError') return true;
  return (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  );
}

/** Un rechargement a-t-il déjà été tenté pour l'incident en cours (pas
 *  encore résolu) ? `sessionStorage` : le flag ne survit pas à la fermeture
 *  de l'onglet ni ne fuit vers les autres onglets. */
export function rechargementDejaTente(): boolean {
  try {
    return sessionStorage.getItem(CLE_TENTATIVE) === '1';
  } catch {
    return false; // sessionStorage indisponible (mode privé strict...) → jamais bloquant
  }
}

/** Marque la tentative — à appeler juste AVANT `window.location.reload()`. */
export function marquerRechargementTente(): void {
  try {
    sessionStorage.setItem(CLE_TENTATIVE, '1');
  } catch {
    // best-effort — un rechargement qui boucle une fois de plus reste sans danger
  }
}

/** À appeler après un rendu réussi de l'appli (`App.tsx`) — un incident déjà
 *  résolu ne doit pas bloquer la PROCHAINE auto-récupération (ex. le
 *  redéploiement suivant, dans le même onglet resté ouvert). */
export function reinitialiserRechargement(): void {
  try {
    sessionStorage.removeItem(CLE_TENTATIVE);
  } catch {
    // best-effort
  }
}
